import { render, staticRenderFns } from "./LicenseAccountApply.vue?vue&type=template&id=b0e6fb3c&scoped=true"
import script from "./LicenseAccountApply.vue?vue&type=script&lang=js"
export * from "./LicenseAccountApply.vue?vue&type=script&lang=js"
import style0 from "./LicenseAccountApply.vue?vue&type=style&index=0&id=b0e6fb3c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6fb3c",
  null
  
)

export default component.exports